<template>
  <div v-if="response">
    <document-container
        documentType="tmc-history-export"
        :tables="tables"
        v-if="tables.tables"
    >

      <div
          slot="raw-header"
      >
        <img src="/config/bison/images/logo.png" alt="" class="logo">

        <div class="header">
          <pagetitle
              :data="{title: 'Zielmarkt Änderungen'}"
          ></pagetitle>
        </div>

      </div>

      <div
          slot="raw-body"
          class="page-block"
      >
        <h2>Liste: "{{ response.listName }}"</h2>
      </div>
      <div
          slot="raw-body"
          class="page-block"
          v-for="product in response.products"
      >
        <TmcListTable
            :id="product.dq"
            :table="tables.findTable(product.dq)"/>
      </div>

    </document-container>

  </div>
</template>

<script>
import DocumentContainer
  from '../document/DocumentContainer'
import BlockMixin
  from '../block/BlockMixin'
import TokenService
  from "../../service/TokenService"
import ProductService
  from "../../service/ProductService"
import {
  TableCollection,
} from "../../model/table/TableCollection"
import TmcListTable
  from "./TmcListTable.vue"
import {
  Table,
} from "../../model/table/Table"

export default {
  components: {
    TmcListTable,
    DocumentContainer,
  },

  name: 'TmcHistoryExport',

  data() {
    return {
      response: null,
      template: null,
      tables: {
        type: TableCollection,
      },
    }
  },

  mixins: [BlockMixin],

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: `/config/test/style/tmc_export.css`,
        },
      ]
    },
  },

  props: {
    environment: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },


  async created() {
    let token

    if (this.$route.query.token) {
      token = this.$route.query.token
    } else {
      token = await TokenService.checkToken()
    }

    ProductService.getTmcHistoryExport(
        this.environment,
        this.appInstance,
        this.id,
        token,
    ).then(res => {
      this.response = res.data.data
      this.tables = new TableCollection(
          ...this.response.products.map(el => {
            return new Table(
                el.dq,
                {wkn: el.wkn, isin: el.isin, name: el.name},
                Object.keys(el.positive).map(key => {
                  return { positive: el.positive[key], negative: el.negative[key]}
                }),
                TmcListTable,
                el.name
            )
          }),
      )
    })
  },

  computed: {
    time() {
      return this.moment().format('DD. MMMM YYYY')
    },
  },
}
</script>

<style lang="scss">
.tmc-history-export {
  table {
    td {
      border-color: rgba(0, 0, 0, .05);
    }

    th:nth-child(2),
    td:nth-child(2) {
      background-color: #f6fee9;
    }

    th:nth-child(3),
    td:nth-child(3) {
      background-color: #fef2f2
    }
  }
}
</style>



// WEBPACK FOOTER //
// TmcHistoryExport.vue?4e8bb58d